module.exports = __webpack_public_path__ + "img/Drivers_Urban_Land_Use.321173c5.jpg";